import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";

// Real MUI-aware RTL: swapped in by App.js when the selected language is
// Arabic, alongside document.documentElement.dir (see src/i18n/index.js).
// This makes MUI-internal positioning (Menu/Drawer/Select anchors, etc.)
// mirror correctly, on top of the existing per-component isArabic overrides.
export const rtlCache = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

export const ltrCache = createCache({
  key: "mui",
});
